import { styled } from '@mui/material';
import { TreeItem, TreeItemProps } from '@mui/x-tree-view';

const StyledTreeItem = styled(TreeItem)<TreeItemProps>(({ theme }) => ({
  '& .MuiTreeItem-label': {
    color: theme.palette.text.primary,
    userSelect: 'none'
  }
}));

export default StyledTreeItem;
